/**
 * FleetManager V3 - KPI Overview Widget
 * Top bar with key metrics (fleet_manager profile)
 */

import React from 'react';
import { useFormat } from '../../../../i18n/format.js';
import { CreditCard, AlertTriangle, Wrench, Fuel } from 'lucide-react';
import { StatCard } from '../../shared/index.js';

export function KPIOverview({ data = {} }) {
  const { t, fmt } = useFormat();
  const {
    costs = { month: 0, trend: 0 },
    claims = { open: 0 },
    maintenance = { compliance: 0 },
    fuel = { consumption: 0, trend: 0 }
  } = data;

  const kpis = [
    {
      icon: CreditCard,
      label: t('dashboard.kpi.costsMonth'),
      value: fmt.money(costs.month, costs.currency || 'EUR', { compact: true }),
      trend: costs.trend,
      color: 'blue'
    },
    {
      icon: AlertTriangle,
      label: t('dashboard.kpi.openClaims'),
      value: claims.open,
      color: 'amber'
    },
    {
      icon: Wrench,
      label: t('dashboard.kpi.preventiveMaintenance'),
      value: fmt.percent(maintenance.compliance / 100, { decimals: 0 }),
      color: 'green'
    },
    {
      icon: Fuel,
      label: t('dashboard.kpi.consumption'),
      value: t('dashboard.kpi.consumptionValue', { value: fmt.number(fuel.consumption, { decimals: 1 }) }),
      trend: fuel.trend,
      color: 'purple'
    }
  ];

  return (
    <div className="grid grid-cols-4 gap-3">
      {kpis.map((kpi, index) => (
        <StatCard
          key={index}
          icon={kpi.icon}
          label={kpi.label}
          value={kpi.value}
          trend={kpi.trend}
          color={kpi.color}
        />
      ))}
    </div>
  );
}

export default KPIOverview;
